import { openDB, IDBPDatabase } from 'idb';

const DB_NAME = 'AuditLogDB';
const STORE_NAME = 'filters';

export class IndexedDBService {
  private static dbPromise: Promise<IDBPDatabase> | null = null;

  private static async initDB(): Promise<IDBPDatabase> {
    if (!this.dbPromise) {
      this.dbPromise = openDB(DB_NAME, 1, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME);
          }
        },
      });
    }
    return this.dbPromise;
  }

  static async save(key: string, value: any): Promise<void> {
    try {
      const db = await this.initDB();
      await db.put(STORE_NAME, value, key);
    } catch (err) {
      console.error(`IndexedDB save error for key "${key}":`, err);
    }
  }

  static async get<T = any>(key: string): Promise<T | null> {
    try {
      const db = await this.initDB();
      return (await db.get(STORE_NAME, key)) as T | null;
    } catch (err) {
      console.error(`IndexedDB get error for key "${key}":`, err);
      return null;
    }
  }

  static async delete(key: string): Promise<void> {
    try {
      const db = await this.initDB();
      await db.delete(STORE_NAME, key);
    } catch (err) {
      console.error(`IndexedDB delete error for key "${key}":`, err);
    }
  }

  static async clear(): Promise<void> {
    try {
      const db = await this.initDB();
      await db.clear(STORE_NAME);
    } catch (err) {
      console.error('IndexedDB clear error:', err);
    }
  }
}
